const STORAGE_KEY = 'demohub_puzzle';

export const SIZES = [3, 4, 5, 6];
export const SIZE_LABELS = { 3: '3×3', 4: '4×4', 5: '5×5', 6: '6×6' };

export function getGoal(size) {
  const arr = [];
  for (let i = 1; i < size * size; i++) arr.push(i);
  arr.push(0);
  return arr;
}

export function isSolvable(tiles, size) {
  let inversions = 0;
  const flat = tiles.filter((t) => t !== 0);
  for (let i = 0; i < flat.length; i++) {
    for (let j = i + 1; j < flat.length; j++) {
      if (flat[i] > flat[j]) inversions++;
    }
  }
  // For odd-sized grids, inversions must be even
  // For even-sized grids, inversions + row of blank from bottom must be odd
  if (size % 2 === 1) {
    return inversions % 2 === 0;
  } else {
    const emptyIndex = tiles.indexOf(0);
    const emptyRowFromBottom = size - Math.floor(emptyIndex / size);
    return (inversions + emptyRowFromBottom) % 2 === 1;
  }
}

export function shuffle(size) {
  let tiles;
  do {
    tiles = getGoal(size).sort(() => Math.random() - 0.5);
  } while (!isSolvable(tiles, size) || isSolved(tiles, size));
  return tiles;
}

export function isSolved(tiles, size) {
  const goal = getGoal(size);
  return tiles.every((t, i) => t === goal[i]);
}

export function canMove(index, tiles, size) {
  const emptyIndex = tiles.indexOf(0);
  const eRow = Math.floor(emptyIndex / size);
  const eCol = emptyIndex % size;
  const tRow = Math.floor(index / size);
  const tCol = index % size;
  return (Math.abs(eRow - tRow) + Math.abs(eCol - tCol)) === 1;
}

export function moveTile(index, tiles, size) {
  if (!canMove(index, tiles, size)) return null;
  const newTiles = [...tiles];
  const emptyIndex = newTiles.indexOf(0);
  newTiles[emptyIndex] = newTiles[index];
  newTiles[index] = 0;
  return newTiles;
}

export function initPuzzle(size) {
  return {
    tiles: shuffle(size),
    size,
    moves: 0,
    time: 0,
    running: false,
    solved: false,
    bestMoves: loadBest(size, 'moves'),
    bestTime: loadBest(size, 'time'),
    history: [],
  };
}

export function loadBest(size, type) {
  try {
    const val = localStorage.getItem(`${STORAGE_KEY}_${size}_best_${type}`);
    return val ? parseInt(val, 10) : null;
  } catch { return null; }
}

export function saveBest(size, type, value) {
  try {
    const current = loadBest(size, type);
    if (current === null || value < current) {
      localStorage.setItem(`${STORAGE_KEY}_${size}_best_${type}`, value.toString());
      return value;
    }
    return current;
  } catch { return value; }
}

export function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

const BASE_COLORS = [
  '#7c83ff', '#e040fb', '#00d2d3', '#ff6b35', '#00c853', '#ffd32a',
  '#ff4757', '#4facfe', '#9b59b6', '#1abc9c', '#e67e22', '#2ecc71',
  '#3498db', '#e74c3c', '#f39c12', '#8e44ad', '#16a085', '#d35400',
  '#27ae60', '#2980b9', '#c0392b', '#f1c40f', '#7f8c8d', '#2c3e50',
  '#1dd1a1', '#ff6348', '#5f27cd', '#54a0ff', '#01a3a4', '#feca57',
  '#ee5a24', '#0abde3', '#10ac84', '#f368e0', '#48dbfb',
];

export function getTileColor(value) {
  if (value === 0) return 'transparent';
  return BASE_COLORS[(value - 1) % BASE_COLORS.length];
}
